export enum FeatureFlags {
    AmsterdamOverspanningen = 'amsterdamOverspanningen',
    Image360 = '360Image',
    Cra = 'CRA',
}
